import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatarParaMoedaBRL } from "../../../utils";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";
import "../Protestos.css";




export default function CreditoScore({
  creditoScore
}: {
  creditoScore: any
}) {
  const { t } = useTranslation();

  const valorBodyTemplate = (rowData: any) => formatarParaMoedaBRL(Number(rowData.VALOR.replace('.', '').replace(',', '.')));




  const getResumoProtesto = () => {
    const resumos: any[] = [];
    if (creditoScore.PROTESTO_SINTETICO && creditoScore.PROTESTO_SINTETICO.OCORRENCIAS && creditoScore.PROTESTO_SINTETICO.OCORRENCIAS.length > 0) {
      const comarcas: any[] = []
      creditoScore.PROTESTO_SINTETICO.OCORRENCIAS.forEach((prot: any) => {
        if (!comarcas.includes(prot.COMARCA)) {
          comarcas.push(prot.COMARCA)
        }
      });
      const valorTotal = creditoScore.PROTESTO_SINTETICO.VALOR_TOTAL
        ? Number(creditoScore.PROTESTO_SINTETICO.VALOR_TOTAL.replace(/\./g, '').replace(',', '.'))
        : 0;
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Comarcas',
        value: comarcas.length
      })
      resumos.push({
        icon: 'pi pi-gauge',
        label: 'Quantidade Protestos',
        value: creditoScore.PROTESTO_SINTETICO.QUANTIDADE_OCORRENCIA
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total Protestos',
        value: formatarParaMoedaBRL(valorTotal)
      })
    }

    return resumos;
  }

  const getResumoProtesto3 = () => {
    const resumos: any[] = [];
    if (creditoScore.PROTESTOS && creditoScore.PROTESTOS.OCORRENCIAS && creditoScore.PROTESTOS.OCORRENCIAS.length > 0) {
      const comarcas: any[] = []
      creditoScore.PROTESTOS.OCORRENCIAS.forEach((prot: any) => {
        if (!comarcas.includes(prot.ORIGEM)) {
          comarcas.push(prot.ORIGEM)
        }
      });
      const valorTotal = creditoScore.PROTESTOS.VALOR_TOTAL
        ? Number(creditoScore.PROTESTOS.VALOR_TOTAL.replace(/\./g, '').replace(',', '.'))
        : 0;
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Comarcas',
        value: comarcas.length
      })
      resumos.push({
        icon: 'pi pi-gauge',
        label: 'Quantidade Protestos',
        value: creditoScore.PROTESTOS.QUANTIDADE_OCORRENCIA
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total Protestos',
        value: formatarParaMoedaBRL(valorTotal)
      })
    }

    return resumos;
  }


  const headerTemplateProtesto = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.PROTESTO_SINTETICO && creditoScore.PROTESTO_SINTETICO.OCORRENCIAS && creditoScore.PROTESTO_SINTETICO.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span>)}</div>;
  }


  const headerTemplatePendencia = (provedor: string) => (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {getOcorrenciasPorProvedor(provedor).length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia') + ' ' + provedor}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia') + ' ' + provedor}</span>)}</div>;
  }

  const headerTemplatePendencia2 = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.PEND_REFIN && creditoScore.PEND_REFIN.OCORRENCIAS && creditoScore.PEND_REFIN.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia2')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia2')}</span>)}</div>;
  }

  const headerTemplatePendencia3 = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.PEND_VENCIDAS && creditoScore.PEND_VENCIDAS.OCORRENCIAS && creditoScore.PEND_VENCIDAS.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia3')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia3')}</span>)}</div>;
  }

  const headerTemplateProtesto3 = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoScore.PROTESTOS && creditoScore.PROTESTOS.OCORRENCIAS && creditoScore.PROTESTOS.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('Protestos 3')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('Protestos 3')}</span>)}</div>;
  }

  const getOcorrenciasPorProvedor = (provedor: string) => {
    if (creditoScore.PEND_FINANCEIRAS && creditoScore.PEND_FINANCEIRAS.OCORRENCIAS && creditoScore.PEND_FINANCEIRAS.OCORRENCIAS.length > 0) {
      return creditoScore.PEND_FINANCEIRAS.OCORRENCIAS.filter((ocorrencia: any) => ocorrencia.INFORMANTE === provedor);
    }
    return [];
  }


  return (
    <div>
      {creditoScore.mensagemErro ? (<p>{creditoScore.mensagemErro}</p>) :
        (<div>
          <br></br>
          {creditoScore.PROTESTO_SINTETICO && creditoScore.PROTESTO_SINTETICO.OCORRENCIAS && (
            <Panel headerTemplate={headerTemplateProtesto}>
              {creditoScore.dados?.protesto.registro.length === 0 ? (<NadaConsta />) : (<>
                <div className="protestos-cards">
                  {getResumoProtesto().map((item: any, index: number) => (

                    <Card className='protestos-card' key={index}>
                      <div className="flex-consulta  justify-content-between gap-5">
                        <div className="flex-consulta  flex-column gap-1">
                          <span style={{ color: 'white' }} className=" text-sm">{item.label}</span>
                          <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                        </div>
                        <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                          <i className={item.icon} />
                        </span>
                      </div>
                    </Card>

                  ))}
                </div>
                <br></br>
                <DataTable size="small" value={creditoScore.PROTESTO_SINTETICO.OCORRENCIAS} responsiveLayout="stack" breakpoint="960px">
                  <Column field="DATA_OCORRENCIA" header={t('data')}></Column>
                  <Column field="CARTORIO" header={t('cartorio')}></Column>
                  <Column field="COMARCA" header={t('cidade')}></Column>
                  <Column field="UF" header={t('uf')}></Column>
                  <Column field="VALOR" header={t('valor')}></Column>
                </DataTable>
              </>)}
            </Panel>)}
          <br></br>
          {creditoScore.PROTESTOS && creditoScore.PROTESTOS.OCORRENCIAS && (
            <Panel headerTemplate={headerTemplateProtesto3}>
              {creditoScore.dados?.protesto.registro.length === 0 ? (<NadaConsta />) : (<>
                <div className="protestos-cards">
                  {getResumoProtesto3().map((item: any, index: number) => (

                    <Card className='protestos-card' key={index}>
                      <div className="flex-consulta  justify-content-between gap-5">
                        <div className="flex-consulta  flex-column gap-1">
                          <span style={{ color: 'white' }} className=" text-sm">{item.label}</span>
                          <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                        </div>
                        <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                          <i className={item.icon} />
                        </span>
                      </div>
                    </Card>

                  ))}
                </div>
                <br></br>
                <DataTable size="small" value={creditoScore.PROTESTOS.OCORRENCIAS} responsiveLayout="stack" breakpoint="960px" >
                  <Column field="DATA" header={t('data')}></Column>
                  <Column field="CARTORIO" header={t('cartorio')}></Column>
                  <Column field="ORIGEM" header={t('origem')}></Column>
                  <Column body={valorBodyTemplate} header={t('valor')}></Column>
                </DataTable>
              </>)}
            </Panel>)}
          <br></br>
          <br></br>
          {creditoScore.PEND_FINANCEIRAS && creditoScore.PEND_FINANCEIRAS.PROVEDORES && (
            <Panel header={t('pendenciaFinanceira')}>
              {creditoScore.PEND_FINANCEIRAS && creditoScore.PEND_FINANCEIRAS.OCORRENCIAS && creditoScore.PEND_FINANCEIRAS.OCORRENCIAS.length > 0 && (
                <div style={{ paddingBottom: '2rem', paddingLeft: '5rem' }}><span style={{ padding: '2rem' }}><b>VALOR TOTAL:</b> {formatarParaMoedaBRL(Number(creditoScore.PEND_FINANCEIRAS.VALOR_TOTAL.replace(',', '.')))} </span><span style={{ padding: '2rem' }}><b>QUANTIDADE DE PENDÊNCIAS HOJE:</b> {creditoScore.PEND_FINANCEIRAS.QUANTIDADE_OCORRENCIA} </span><span style={{ padding: '2rem' }}><b>ÚLTIMA OCORRÊNCIA:</b> {creditoScore.PEND_FINANCEIRAS.ULTIMO_VENCIMENTO} </span></div>
              )}
              {creditoScore.PEND_FINANCEIRAS.PROVEDORES.map((provedor: any) => (
                <div>
                  <Panel headerTemplate={headerTemplatePendencia(provedor.PROVEDOR)}>
                    {getOcorrenciasPorProvedor(provedor.PROVEDOR).length === 0 ? (<NadaConsta />) : (<>
                      <DataTable size="small" value={getOcorrenciasPorProvedor(provedor.PROVEDOR)} responsiveLayout="stack" breakpoint="960px">
                        <Column field="DATA_INCLUSAO" header={t('data')}></Column>
                        <Column field="DATA_VENCIMENTO" header={t('vencimento')}></Column>
                        <Column field="CONTRATO" header={t('contrato')}></Column>
                        <Column field="ORIGEM" header={t('origem')}></Column>
                        <Column field="TIPO_DEVEDOR" header={t('tipo')}></Column>
                        <Column field="CREDOR" header={t('informante')}></Column>
                        <Column body={(item) => formatarParaMoedaBRL(Number(item.VALOR.replace(',', '.')))} field="VALOR" header={t('valor')}></Column>
                      </DataTable>
                    </>)}
                  </Panel>
                  <br></br>
                </div>
              ))}
            </Panel>
          )}
          <br></br>
          <Panel headerTemplate={headerTemplatePendencia2}>
            {!creditoScore.PEND_REFIN || !creditoScore.PEND_REFIN.OCORRENCIAS || creditoScore.PEND_REFIN.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (<>
              <DataTable size="small" value={creditoScore.PEND_REFIN.OCORRENCIAS} responsiveLayout="stack" breakpoint="960px">
                <Column field="DATA_INCLUSAO" header={t('data')}></Column>
                <Column field="DATA_VENCIMENTO" header={t('vencimento')}></Column>
                <Column field="CONTRATO" header={t('contrato')}></Column>
                <Column field="ORIGEM" header={t('origem')}></Column>
                <Column field="TIPO_DEVEDOR" header={t('tipo')}></Column>
                <Column field="CREDOR" header={t('informante')}></Column>
                <Column field="VALOR" header={t('valor')}></Column>
              </DataTable>
            </>)}
          </Panel>
          <br></br>
          <Panel headerTemplate={headerTemplatePendencia3}>
            {!creditoScore.PEND_VENCIDAS || !creditoScore.PEND_VENCIDAS.OCORRENCIAS || creditoScore.PEND_VENCIDAS.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (<>
              <DataTable size="small" value={creditoScore.PEND_VENCIDAS.OCORRENCIAS} responsiveLayout="stack" breakpoint="960px">
                <Column field="DATA_INCLUSAO" header={t('data')}></Column>
                <Column field="DATA_VENCIMENTO" header={t('vencimento')}></Column>
                <Column field="CONTRATO" header={t('contrato')}></Column>
                <Column field="ORIGEM" header={t('origem')}></Column>
                <Column field="TIPO_DEVEDOR" header={t('tipo')}></Column>
                <Column field="CREDOR" header={t('informante')}></Column>
                <Column field="VALOR" header={t('valor')}></Column>
              </DataTable>
            </>)}
          </Panel>
          <br></br>

        </div>)}
    </div>
  )
}